import { Row, Typography, Col, Card, Button, Modal, message, Radio, Spin } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import HTTPClient from "../../../utils/HTTPClient";
import { useNavigate } from "react-router-dom";

const CreateFromAiCard = ({ setLoading, showBuyModal, setShowBuyModal }) => {
    const { t } = useTranslation();
    const [aiProjectId, setAiProjectId] = useState(false);
    //
    const [plan, setPlan] = useState("yearly");

    const navigate = useNavigate();

    useEffect(() => {
        const projectUid = Cookies.get("ai_id");
        if (projectUid) {
            Cookies.set("last_ai_id", projectUid)
            Cookies.remove("ai_id");
            message.success(t("builder.create.ai.creation"));
            createProject(projectUid);
            setAiProjectId(projectUid);
        }
    }, []);

    const handlePlanChange = (e) => {
        setPlan(e.target.value);
    };

    const createProject = async (ai_id) => {
        try {
            await HTTPClient.post("/builder/projects", { ai_id });
            message.success(t("builder.create.ai.success"));
        } catch (e) {
            // redirect to editor
            if (e.response.status === 303) {
                window.location.replace(e.response.data);
                setLoading(true)
            }
            // show buy modal
            if (e.response.status === 402) {
                setShowBuyModal(true);
            }
        }
    };

    const buyProject = async (subscription_type) => {
        const body = {
            subscription_type,
            ai_id: aiProjectId,
        };
        try {
            await HTTPClient.post("/stripe/create_builder_checkout_session", body);
            message.success(t("builder.list.update.success"));
        } catch (e) {
            // redirect to checkout portal
            if (e.response.status === 303) {
                window.location.replace(e.response.data);
                return;
            }
            const { error_code } = e?.response?.data;
            message.error(t([`errors.${error_code}`, "builder.list.error"]));
        }
    };

    return (
        <>
            <Card
                bordered={true}
                style={{
                    width: "100%",
                    borderRadius: "10px",
                    marginTop: "20px",
                }}>
                <Row>
                    <Col xs={24} s={24} md={24} lg={12} xl={12}>
                        <img src="/ai-create.png" style={{ width: "90%" }} />
                    </Col>
                    <Col
                        xs={24}
                        s={24}
                        md={24}
                        lg={12}
                        xl={12}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}>
                        <div>
                            <Row>
                                <Typography.Text
                                    style={{
                                        fontSize: "medium",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                    }}>
                                    {t("builder.create.ai.title")}
                                </Typography.Text>
                            </Row>
                            <Row
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                }}>
                                {t("builder.create.ai.subtitle")}
                            </Row>
                        </div>

                        <Row
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "20px",
                            }}>
                            <a
                                href="https://ai-builder.appbox.cloud/"
                                target="_blank"
                                style={{ width: "100%" }}>
                                <Button type="primary" style={{ width: "100%" }} size="large">
                                    {t("builder.create.ai.call_to_action")}
                                </Button>
                            </a>
                        </Row>
                    </Col>
                </Row>
            </Card>
            <Modal
                title={t("builder.create.buy_modal.title")}
                open={showBuyModal}
                footer={null}
                onCancel={() => setShowBuyModal(false)}>
                <Row align="middle" style={{ textAlign: "center" }}>
                        <Col span={8}>
                            <img src="/alert.png" alt="Hurry up" style={{ height: "120px" }} />                        
                        </Col>
                        <Col span={16}>
                            <Row>
                                <Typography.Text>{t("builder.create.buy_modal.text")}</Typography.Text>
                            </Row>
                        </Col>
                    </Row>
                <Row style={{ display: "flex", justifyContent: "center", marginTop: "10px"}}>
                    <Radio.Group onChange={handlePlanChange} value={plan} buttonStyle="solid">
                        <Radio.Button value="monthly">{t("builder.list.go_pro_modal.month")}</Radio.Button>
                        <Radio.Button value="yearly">{t("builder.list.go_pro_modal.year")}</Radio.Button>
                    </Radio.Group>
                </Row>
                <Row style={{ marginTop: "40px", display: "flex", justifyContent: "center" }}>
                    <Col span={16}>
                        <Row>
                            <Col span={3}></Col>
                            <Col span={4}>
                                <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "26px" }} />                        
                            </Col>
                            <Col span={15}>
                                <Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{plan==="monthly" ? t("builder.list.go_pro_modal.pro1a") : t("builder.list.go_pro_modal.pro1b") }</Typography.Text>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "15px" }}>
                            <Col span={3}></Col>
                            <Col span={4}>
                                <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "26px" }} />                        
                            </Col>
                            <Col span={15}>
                                <Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("builder.list.go_pro_modal.pro2")}</Typography.Text>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "15px" }}>
                            <Col span={3}></Col>    
                            <Col span={4}>
                                <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "26px" }} />                        
                            </Col>
                            <Col span={15}>
                                <Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("builder.list.go_pro_modal.pro3")}</Typography.Text>
                            </Col>
                        </Row>
                        {plan === "yearly" && 
                            <Row style={{ marginTop: "10px" }}>
                                <Col span={3}></Col>    
                                <Col span={4}>
                                    <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "26px" }} />                        
                                </Col>
                                <Col span={15}>
                                    <Typography.Text style={{ fontSize: "18px", fontWeight: "bold" }}>{t("builder.list.go_pro_modal.pro4")}</Typography.Text>
                                </Col>
                            </Row>    
                        }
                    </Col>
                </Row>
                <Row style={{ marginTop: "40px", display: "flex", justifyContent: "center" }}>
                    <Button type="primary" onClick={() => buyProject(plan)}>
                        {t("builder.create.buy_modal.call_to_action")}
                    </Button>
                </Row>
            </Modal>
        </>
    );
};

export { CreateFromAiCard };
